import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/element.js'
import '@/assets/less/index.less'
import api from './api'
import vueHashCalendar from 'vue-hash-calendar'
import 'vue-hash-calendar/lib/vue-hash-calendar.css'
Vue.use(vueHashCalendar)
Vue.config.productionTip = false
api.init(router)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
